export var focusClass = 'focused';
export var isFirstClass = 'is-first';
export var activeClass = 'active';
export var errorClass = 'error';
export var lowCapabilityClass = 'low-capability';
export var shouldAnimateClass = 'should-animate';
export var browseContainerClass = 'browse-container';